import { Stack } from "flicket-ui";
import { useState } from "react";
import { ExpressCheckoutMobileToggle } from "./MobileToggle";
import { ExpressOrderSummaryContent } from "./OrderSummaryContent";

export const OrderSummary = () => {
  const [
    isMobileOrderSummaryExpanded,
    setIsMobileOrderSummaryExpanded,
  ] = useState(false);

  return (
    <Stack direction={"vertical"}>
      <ExpressCheckoutMobileToggle
        isExpanded={isMobileOrderSummaryExpanded}
        setIsExpanded={setIsMobileOrderSummaryExpanded}
      />
      <ExpressOrderSummaryContent
        isExpanded={isMobileOrderSummaryExpanded}
        displayTotal={true}
      />
    </Stack>
  );
};
